/**
 * TODO: Rename this to EBreakpointsInPx.
 */
export enum BreakpointsInPx {
  BREAKPOINT_1 = 640,
  BREAKPOINT_2 = 768,
  BREAKPOINT_3 = 1024,
  BREAKPOINT_4 = 1280,
  BREAKPOINT_5 = 1536
}
